import React, { Fragment } from "react";
import { Col } from "antd";
import Description from "./Description";
import Experience from "./Experience";
import Awards from "./Awards";
import Location from "./Location";
import About from "./About";
import RatingPanel from "./RatingPanel";

import ExperienceAccordian from "./Accordians/ExperienceAccordian";
import AboutAccordian from "./Accordians/AboutAccordian";
import DescriptionAccordian from "./Accordians/DescriptionAccordiant";
import RatingPanelAccordian from "./Accordians/RatingPanelAccordian";
import LocaitonAccordian from "./Accordians/LocationAccordian";
import AwardsAccordian from "./Accordians/AwardsAccordian";
import { useSelector } from "react-redux";
import { PROFILE } from "../../Store/Features/ProfileSlice";
import { EVENT } from "../../Store/Features/EventSlice";
import { ROLES } from "../../Config/helpers/constants";
import { useLocation } from "react-router-dom";
import OtherAccordian from "./Accordians/OtherAccordian";
import Other from "./Other";
import CurrentEvents from "./CurrentEvents";
import CurrentEventsAccordian from "./Accordians/CurrentEventsAccordian";

function SideBar({
  about,
  other,
  description,
  ratingPanel,
  experience,
  location,
  md,
  awards = true,
  contracts,
  big,
  type,
  data,
  currentEvents
}) {
  var currentProfile = useSelector(PROFILE);
  var event = useSelector(EVENT);
  const des = JSON.parse(localStorage.getItem("viewer"))?.description;

  const { pathname } = useLocation();

  var currentPageFor = pathname.includes("view/panel") ? ROLES.panel : null;

  const teamProfile = pathname.includes("player/team/"); // For Team About
  const panel = pathname.includes("organizer/panel/"); // For Panel About

  const formatDate = (dobString) => {
    if (!dobString) return null;
    const date = new Date(dobString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  };

  let establishDate = currentProfile?.establish || currentProfile?.data?.establish;

  const formattedDOB = formatDate(currentProfile?.dob);
  const formatedEstablish = formatDate(establishDate);

  return (
    <Fragment>
      <Col xs={24} sm={24} md={24} lg={big ? 24 : md ? 9 : 6} xl={big ? 24 : 6}>
        {description && (
          <Fragment>
            <div className="d-md-block d-none">
              <DescriptionAccordian description={currentProfile?.description || des} />
            </div>
            <div className="d-md-none">
              <Description description={currentProfile?.description || des} />
            </div>
          </Fragment>
        )}
        {/* About */}
        {about && (
          <Fragment>
            <div className="d-md-block d-none">
              <AboutAccordian
                data={event}
                typeOfSports={teamProfile && currentProfile?.typeofsports}
              />
            </div>
            <div className="d-md-none">
              <About
                data={event || currentProfile}
                typeOfSports={teamProfile && currentProfile?.typeofsports}
                rulesAndRegulations={{
                  text: currentProfile?.rules || event?.rules,
                  file: currentProfile?.rulesFile || event?.rulesFile
                }}
              />
            </div>
          </Fragment>
        )}
        {/* Other  */}
        {other && (
          <Fragment>
            <div className="d-md-block d-none">
              <OtherAccordian
                dob={formattedDOB}
                establish={(teamProfile || panel) && formatedEstablish}
                sportType={currentProfile?.sportType || currentProfile?.sportsyouplay}
                nickname={currentProfile?.nickname}
                typeOfSports={teamProfile && currentProfile?.typeofsports}
              />
            </div>
            <div className="d-md-none">
              <Other
                dob={formattedDOB}
                establish={(teamProfile || panel) && formatedEstablish}
                sportType={currentProfile?.sportType || currentProfile?.sportsyouplay}
                nickname={currentProfile?.nickname}
                typeOfSports={teamProfile && currentProfile?.typeofsports}
              />
            </div>
          </Fragment>
        )}
        {/* Rating Panel */}
        {ratingPanel && (
          <Fragment>
            <div className="d-md-block d-none">
              <RatingPanelAccordian
                Rating={currentProfile?.rating || 0}
                id={currentProfile?._id}
                type={currentPageFor}
              />
            </div>
            <div className="d-md-none">
              <RatingPanel
                Rating={currentProfile?.rating || 0}
                id={currentProfile?._id}
                type={currentPageFor}
              />
            </div>
          </Fragment>
        )}
        {experience ? (
          <Fragment>
            <div className="d-md-block d-none">
              <ExperienceAccordian />
            </div>
            <div className="d-md-none">
              <Experience />
            </div>
          </Fragment>
        ) : null}

        {contracts && contracts}

        {/* Awards */}
        {!currentEvents && awards && (
          <Fragment>
            <div className="d-md-block d-none">
              <AwardsAccordian type={type} data={type === "event" ? data : null} />
            </div>
            <div className="d-md-none">
              <Awards type={type} data={type === "event" ? data : null} />
            </div>
          </Fragment>
        )}
        {/* Location */}
        {location ? (
          <Fragment>
            <div className="d-md-block d-none">
              <LocaitonAccordian data={event?.location ? event : currentProfile} />
            </div>
            <div className="d-md-none">
              <Location data={event?.location ? event : currentProfile} />
            </div>
          </Fragment>
        ) : null}

        {currentEvents ? (
          <Fragment>
            <div className="d-md-block d-none">
              <CurrentEventsAccordian />
            </div>
            <div className="d-md-none">
              <CurrentEvents />
            </div>
          </Fragment>
        ) : null}
      </Col>
    </Fragment>
  );
}

export default SideBar;
